import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=b64cc688"
import script from "./HeaderBar.vue?vue&type=script&lang=js"
export * from "./HeaderBar.vue?vue&type=script&lang=js"
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=b64cc688&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports